module.exports = __webpack_public_path__ + "img/palm.be5030ca.webp";